import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';
import { LeaderboardResponse } from '../../models/api/responses/leaderboard.response';
import { LeaderboardService } from '../../services/leaderboard.service';
import { LeaderboardActions } from '../actions/actions-type.action';

@Injectable()
export class LeaderboardEffect {
    private actions$ = inject(Actions);
    private leaderBoardService = inject(LeaderboardService);

    fetchLeaderBoardStatisticData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LeaderboardActions.fetchLeaderboardStatisticData),
            switchMap(({ payload }) =>
                this.leaderBoardService
                    .fetchLeaderBoardStatisticData(
                        payload.type,
                        payload.filters
                    )
                    .pipe(
                        map((response: LeaderboardResponse) =>
                            LeaderboardActions.fetchLeaderboardStatisticDataSuccess(
                                {
                                    payload: response,
                                }
                            )
                        ),
                        catchError((response: BadResponseWithError) =>
                            of(
                                LeaderboardActions.fetchLeaderboardStatisticDataFailure(
                                    { error: response }
                                )
                            )
                        )
                    )
            )
        )
    );
}
